export const formatTokenPrefix = (prefix: string): string => `${prefix}...`;
